import { createSlice } from "@reduxjs/toolkit";
const transactionsSlice = createSlice({
    name: 'transactions',
    initialState: {
        transactionsList: [],
        orderIds: {}
    },
    reducers: {
        setTransactionsList: (state, action) => {
            state.transactionsList = action.payload.transactionsList
            state.orderIds = action.payload.orderIds
        }
    }
});
export const addTransactionsList = transactionsSlice.actions.setTransactionsList;
export default transactionsSlice.reducer;
